import {
  IntegrationCampaign,
  IntegrationType,
} from '@aibees/elephant/types/integration';
import {
  PaginationRequest,
  PaginationResponse,
} from '@aibees/shared/definition';
import { QueryOptions } from '@aibees/shared/http';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { INTEGRATION_API_PREFIX } from './constants';

type BrowseIntegrationRequest = PaginationRequest<{
  id?: string;
  type?: IntegrationType;
  search?: string;
  size?: number;
}>;
export function useBrowseCampaignApi(
  params: BrowseIntegrationRequest,
  options?: QueryOptions
) {
  const workspace = useWorkspace();
  const { page, id, type, search, size, ...other } = params;

  return useBaseQuery<typeof params, PaginationResponse<IntegrationCampaign>>(
    [useBrowseCampaignApi.name, page, id, type, search, size, other],
    {
      url: `${INTEGRATION_API_PREFIX.replace(
        ':wid',
        String(workspace?.id)
      )}/${type}/${id}/campaigns`,
      params: {
        ...other,
        search,
        size,
      },
    },
    options
  );
}
